import { render, staticRenderFns } from "./card-segnalazione-completa.vue?vue&type=template&id=7577183e&"
import script from "./card-segnalazione-completa.vue?vue&type=script&lang=js&"
export * from "./card-segnalazione-completa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
